import "./fristNavbar.css";
import { Link } from "react-router-dom";

const FristNavbar = ({ theme, toggleTheme }) => {
  return (
    <section id="f-N">
      <div className="container">
        <div className="row py-2">
          <div className="col-12 d-flex justify-content-end gap-2 align-items-center">
            {/* Theme Toggle - Only Dark/Light */}
            <button
              className="btn btn-sm btn-outline-light border-0"
              onClick={toggleTheme}
              title={`Switch to ${theme === 'light' ? 'Dark' : 'Light'} Mode`}
            >
              {theme === 'light' ? '☀️' : '🌙'}
            </button>

            <div className="dropdown mt-0 d-none d-lg-block">
              <button type="button" data-bs-toggle="dropdown" className="btn btn-sm text-white">
                English
                <i className="bi bi-chevron-down mx-1" />
              </button>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="#">
                    English
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FristNavbar;
